import {
    cleanCommonParams,
    mapProductsParams,
    mapStatesParams,
    mapBrandsParams,
    mapVideoParams,
} from './common';

const mapCoBrandedVideoTemplateParams = (
    isCreate,
    {
        products,
        states,
        brands,
        video,
        preview_url,
        transition_time,
        ...params
    },
) => {
    return new Promise((resolve) => {
        resolve({
            co_branded_video_template: {
                ...cleanCommonParams(params),
                ...mapProductsParams(isCreate, products),
                ...mapStatesParams(isCreate, states),
                ...mapBrandsParams(isCreate, brands),
                ...mapVideoParams(isCreate, video),
            },
        });
    });
};

export { mapCoBrandedVideoTemplateParams };
